import { useContext } from 'react';
import type { AuthContextValue } from '../../types/auth';
import { AuthContext } from './auth-context';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth deve ser usado dentro de <AuthProvider>.');
  return ctx;
}
